<template>
  <v-container primary fill-height fluid>
    <v-layout column align-center>
      <v-flex grow>
        <v-alert
          v-model="isError"
          dismissible
          type="error"
          transition="fade-transition"
        >
          {{ errMessage }}
        </v-alert>
      </v-flex>
      <v-flex mb-3>
        <p style="text-align: center;">
          <img style="max-width: 250px;" src="/img/newfocus-white-text.png" alt="NewFocus Logo" />
        </p>
      </v-flex>
      <v-flex>
        <v-form @submit="submit">
          <v-layout column>
            <v-flex>
              <v-text-field
                v-model="email"
                label="Email Address"
                required
                dark
                id="email"
                color="secondary"
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="Password"
                type='password'
                required
                dark
                id="password"
                color="secondary"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-layout row>
                <v-flex grow ma-1>
                  <v-btn
                    block
                    dark
                    outline
                    class="secondary"
                    type="submit"
                    id="submit"
                    :disabled="isLoading"
                    :loading="isLoading"
                  >
                    Log In
                  </v-btn>
                </v-flex>
                <v-flex grow ma-1>
                  <v-btn
                    block
                    dark
                    outline
                    class="secondary"
                    to="/signup"
                    id="signup"
                  >
                    Sign Up
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout row>
                <v-flex grow ma-1>
                  <v-btn
                    block
                    dark
                    outline
                    to="/forgot"
                    id="forgot"
                  >
                    Forgot Password?
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout row>
                <v-flex grow ma-1 v-if="$root.isGoogleAvailable">
                  <v-btn
                    block
                    dark
                    outline
                    class="secondary"
                    @click="this.$root.googleLogin"
                    id="googleSubmit"
                  >
                    Google Login
                  </v-btn>
                </v-flex>
                <v-flex grow ma-1 v-if="$root.isFacebookAvailable">
                  <v-btn
                    block
                    dark
                    outline
                    class="secondary"
                    @click="this.$root.facebookLogin"
                    id="facebookSubmit"
                  >
                    Facebook Login
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    isLoading: false,
    email: '',
    password: '',
    isError: false,
    errMessage: null
  }),
  methods: {
    submit (ev) {
      ev.preventDefault()

      this.isLoading = true
      this.$auth.login({
        data: {
          email: this.email,
          password: this.password
        },
        success: function (res) {
          // Store the ID token that was in the response body
          this.$auth.token('id', res.data.token)
        },
        error: function (res) {
          this.isLoading = false
          switch (res.response.status) {
            case 400:
              this.errMessage = res.response.data.err
              this.isError = true
              break
          }
        }
      })
    }
  },
  mounted: function () {
    if (this.$auth.flashMessage) {
      this.errMessage = this.$auth.flashMessage
      this.isError = true

      delete this.$auth.flashMessage
    }
  }
}
</script>
